<template>
  <button id="googleAuth" class="social-signin-google">
    <i class="icon-google"></i>
    Continue with Google
  </button>
</template>
<script>
import AutorizationService from '@/services/AutorizationService';
import autorization from '@/mixins/autorization';

export default {
  mixins: [autorization],
  mounted() {
    this.$nextTick(() => {
      this.startApp();
    });
  },
  methods: {
    attachSignin(auth2, element) {
      auth2.attachClickHandler(
        element,
        {},
        async (googleUser) => {
          const profile = googleUser.getBasicProfile();
          const idToken = googleUser.getAuthResponse().id_token;
          const data = {
            provider: 'google',
            client_id: profile.getId(),
            data: googleUser,
            email: profile.getEmail(),
            name: profile.getName(),
            avatar: profile.getImageUrl(),
            id_token: idToken,
          };
          try {
            const { headers } = await AutorizationService.connect(data);
            this.setAutorization(headers);
          } catch (error) {
            console.log(error);
          }
        },
        (error) => {
          console.log(error);
        },
      );
    },
    startApp() {
      if (!window.gapi || typeof window.gapi.load !== 'function') {
        // Google API script not loaded (deprecated/blocked) — skip silently
        return;
      }
      window.gapi.load('auth2', () => {
        const auth2 = window.gapi.auth2.init({
          client_id: '755326589580-711qhr6neli26tkshsvt468rob9oppfs.apps.googleusercontent.com',
          cookiepolicy: 'single_host_origin',
        });
        const el = document.querySelector('#googleAuth');
        if (el) this.attachSignin(auth2, el);
      });
    },
  },
};
</script>
